import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import { ERRORS } from 'app/config/constants';
import { showToast } from 'app/shared/util/toast.util';
import { toast } from 'react-toastify';

export const initialCaseState: any = {
  idCase: null,
  classification: null,
};

export type CaseState = Readonly<typeof initialCaseState>;

export const fetchCase = idCase => async dispatch => {
  await axios
    .get<any>(`api/cases/${idCase}`)
    .then(result => {
      dispatch(setCase(result.data));
    })
    .catch(error => {
      if (Object.values(ERRORS).includes(error.data.message)) {
        showToast(toast.error, error.data.message);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    });
};

export const fetchCaseInPreview = (idCase: string) => async dispatch => {
  await axios
    .get<any>(`api/cases/${idCase}/case-preview`)
    .then(result => {
      dispatch(setCase(result.data));
    })
    .catch(error => {
      if (Object.values(ERRORS).includes(error.data.message)) {
        showToast(toast.error, error.data.message);
      } else {
        showToast(toast.error, ERRORS.GENERIC_ERROR);
      }
    });
};

export const CaseSlice = createSlice({
  name: 'caseSlice',
  initialState: initialCaseState as CaseState,
  reducers: {
    setCase(state, action) {
      return {
        ...state,
        idCase: action.payload.idCase,
        webId: action.payload.webId,
        classification: action.payload.classification,
        caseCategory: action.payload.caseCategory,
        caseStatus: action.payload.caseStatus,
        caseActivity: action.payload.caseActivity,
        caseActions: action.payload.caseActions,
        caseTabs: action.payload.caseTabs,
        canCreateEarhivaConfirmation: action.payload.canCreateEarhivaConfirmation,
      };
    },
  },
});

export const { setCase } = CaseSlice.actions;
export default CaseSlice.reducer;
